// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quote-request-page {
  animation: fadeIn 0.5s ease-in-out;
  padding: 20px;
  max-width: 100%;
  overflow-x: hidden;
}
.page--empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70vh;
  text-align: center;
}
.page--empty img {
  width: 100px;
  height: 100px;
  margin-bottom: 24px;
  opacity: 0.8;
}
.page--empty h3 {
  font-size: 20px;
  font-weight: 500;
  color: #6b7280;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}
.page-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}
.page-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.filter-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
}
.filter-btn img {
  height: 20px;
}

.page-search-bar {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0 12px;
  width: 300px;
}
.page-search-bar img {
  height: 16px;
  opacity: 0.5;
}
.page-search-bar input {
  border: none;
  outline: none;
  padding: 10px 8px;
  font-size: 14px;
  flex-grow: 1;
  background: transparent;
}

.table-container {
  background-color: #fff;
  border-radius: 12px;
  overflow-x: auto;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
}
.data-table th,
.data-table td {
  padding: 16px 24px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
  font-size: 14px;
  white-space: nowrap;
}
.data-table th {
  background-color: #f2f7ff;
  color: #1e3a8a;
  font-weight: 600;
  font-size: 14px;
  text-transform: none;
}
.data-table td {
  color: #374151;
}
.data-table tbody tr:last-child td {
  border-bottom: none;
}
.action-icons-container {
  display: flex;
  align-items: center;
  gap: 20px;
}
.action-icon {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
  width: 20px;
  height: 20px;
}
.action-icon:hover {
  opacity: 1;
}

.table-container::-webkit-scrollbar {
  height: 8px;
}
.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.table-container::-webkit-scrollbar-thumb {
  background-color: #f97316;
  border-radius: 10px;
  border: 2px solid #f1f1f1;
}
.table-container::-webkit-scrollbar-thumb:hover {
  background-color: #ea580c;
}

@media (max-width: 992px) {
  .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }
  .page-controls {
    justify-content: space-between;
  }
}

@media (max-width: 768px) {
  .data-table thead {
    display: none;
  }
  .data-table tr {
    display: block;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    margin-bottom: 1rem;
    padding: 1rem;
  }
  .data-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f3f4f6;
    white-space: normal;
  }
  .data-table td:last-child {
    border-bottom: none;
  }
  .data-table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #4b5563;
  }
}

@media (max-width: 480px) {
  .page-header h3,
  .page--empty h3 {
    font-size: 16px;
  }
  .data-table td {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/QuoteRequestPage/QuoteRequestPage.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".quote-request-page {\n  animation: fadeIn 0.5s ease-in-out;\n  padding: 20px;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n.page--empty {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 70vh;\n  text-align: center;\n}\n.page--empty img {\n  width: 100px;\n  height: 100px;\n  margin-bottom: 24px;\n  opacity: 0.8;\n}\n.page--empty h3 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n.page-header h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0;\n}\n.page-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.filter-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  border-radius: 6px;\n  padding: 8px;\n  cursor: pointer;\n}\n.filter-btn img {\n  height: 20px;\n}\n\n.page-search-bar {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 0 12px;\n  width: 300px;\n}\n.page-search-bar img {\n  height: 16px;\n  opacity: 0.5;\n}\n.page-search-bar input {\n  border: none;\n  outline: none;\n  padding: 10px 8px;\n  font-size: 14px;\n  flex-grow: 1;\n  background: transparent;\n}\n\n.table-container {\n  background-color: #fff;\n  border-radius: 12px;\n  overflow-x: auto;\n}\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.data-table th,\n.data-table td {\n  padding: 16px 24px;\n  text-align: left;\n  border-bottom: 1px solid #f3f4f6;\n  font-size: 14px;\n  white-space: nowrap;\n}\n.data-table th {\n  background-color: #f2f7ff;\n  color: #1e3a8a;\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: none;\n}\n.data-table td {\n  color: #374151;\n}\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n.action-icons-container {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n.action-icon {\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n  width: 20px;\n  height: 20px;\n}\n.action-icon:hover {\n  opacity: 1;\n}\n\n.table-container::-webkit-scrollbar {\n  height: 8px;\n}\n.table-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n.table-container::-webkit-scrollbar-thumb {\n  background-color: #f97316;\n  border-radius: 10px;\n  border: 2px solid #f1f1f1;\n}\n.table-container::-webkit-scrollbar-thumb:hover {\n  background-color: #ea580c;\n}\n\n@media (max-width: 992px) {\n  .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n  }\n  .page-controls {\n    justify-content: space-between;\n  }\n}\n\n@media (max-width: 768px) {\n  .data-table thead {\n    display: none;\n  }\n  .data-table tr {\n    display: block;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n    padding: 1rem;\n  }\n  .data-table td {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid #f3f4f6;\n    white-space: normal;\n  }\n  .data-table td:last-child {\n    border-bottom: none;\n  }\n  .data-table td::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: #4b5563;\n  }\n}\n\n@media (max-width: 480px) {\n  .page-header h3,\n  .page--empty h3 {\n    font-size: 16px;\n  }\n  .data-table td {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
